export default __webpack_public_path__ + "static/media/nut_logo.019c0bc1.jpg";